<template>
  <v-dialog
    :value="value"
    persistent
    max-width="400"
    @input="$emit('input', $event)"
  >
    <v-card>
      <div class="modal-container">
        <div class="modal-header">
          <div class="info-icon" :style="iconCircleStyle">
            <v-icon color="black" size="24">
              mdi-ticket-confirmation-outline
            </v-icon>
          </div>

          <div class="header-headline">
            อย่าลืมใช้โค้ด Hand Raiser<br />
            เพื่อรับสิทธิพิเศษ จาก SAMSUNG
          </div>
        </div>

        <div class="modal-footer">
          <v-btn
            depressed
            rounded
            block
            large
            dark
            color="primary"
            @click="onConfirm"
          >
            ดำเนินการต่อโดยไม่ใช้โค้ด
          </v-btn>

          <v-btn
            outlined
            rounded
            block
            large
            color="primary"
            @click="onClose"
          >
            <v-icon size="18" class="mr-2">
              mdi-arrow-left
            </v-icon>
            ย้อนกลับไปใช้โค้ด
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import colorBnn from '@/config/color'

export default {
  name: 'CheckoutModalHandraiserWarning',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    iconCircleStyle() {
      return {
        backgroundColor: colorBnn['color-bnn-mid'],
      }
    },
  },

  methods: {
    onClose() {
      this.$emit('input', false)
    },

    onConfirm() {
      this.$emit('input', false)
      this.$emit('confirm')
    },
  },
}
</script>

<style lang="stylus" scoped>
.modal-container {
    position: relative;
    overflow: auto;
    max-height: 75vh;
}

.modal-header {
    padding: 24px 24px 16px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;

    .info-icon {
        display: flex;
        align-items: center;
        justify-content: center;

        width: 48px;
        height: 48px;
        border-radius: 50%;
    }

    .header-headline {
        font-size: 18px;
        font-weight: 700;
        color: rgba(#000000, 0.85);
        text-align: center;
    }
}

.modal-footer {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 8px 24px 24px;
}
</style>
